import React from "react"

const SectionHeader = ({ title, description }) => (
  <>
    <h2 style={{ color: '#808080' }}>{title}</h2>
    <p style={{ color: '#B0B8BA' }}>{description}</p>
  </>
)

export default SectionHeader